<script lang="ts">
  import type { IUser } from "../../types";
  import { fade } from "svelte/transition";
  import BackEnd from "../../lib/BackEnd";
  import { userList } from "../../lib/Store";

  export let user: IUser;

  const reloadUserList = () => {
    BackEnd.getUserList().then((ok) => {
      userList.set(ok);
    });
  };

  const onSubmit = (ev) => {
    BackEnd.saveUser(user).then((ok) => {
      reloadUserList();
    });
  };

  const onDelete = () => {
    var answer = window.confirm("Are you sure?");
    if (answer) {
      BackEnd.deleteUser(user).then((ok) => reloadUserList());
    }
  };
</script>

<div in:fade>
  <form on:submit|preventDefault={onSubmit}>
    <div>
      <label for="key">KEY:</label>
      <input type="text" name="key" id="key" value={user?.key} readonly />
    </div>
    <div>
      <label for="name">Name:</label>
      <input type="text" name="name" id="name" bind:value={user.name} />
    </div>
    {#if user.type !== "admin"}
      <button on:click|preventDefault={onDelete}>Delete</button>
    {/if}
    <button type="submit">Save</button>
  </form>
</div>
